'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _rtveUtil = require('lib/rtveLab/rtveUtil');

var _rtveUtil2 = _interopRequireDefault(_rtveUtil);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RichLink = function RichLink(props, context) {
	var element = props.element;

	var estrenoInfo = void 0;
	var customClass = void 0;
	if (props.inactiveClass) {
		var iAmInactive = false;
		if (element.customClass) {
			iAmInactive = true;
		}
		customClass = (0, _classnames2.default)({
			'richLink': true,
			'inactive': iAmInactive
		});
	} else {
		customClass = (0, _classnames2.default)({
			'richLink': true
		});
	}
	if (props.moreInfo && element.estreno) {
		estrenoInfo = _react2.default.createElement(
			'div',
			{ className: 'estreno' },
			' ',
			_react2.default.createElement(
				'p',
				null,
				' ',
				element.estreno,
				' '
			),
			' '
		);
	}
	var content = _react2.default.createElement(_components.Button, { customClass: element.customClass, icon: element.icon, name: element.name, text: element.text, extraContent: element.extra });
	var bgImage = {
		backgroundImage: element.backgroundImage ? 'url(' + context.baseUrl + element.backgroundImage + ')' : ''
	};

	var richLink = _rtveUtil2.default.isExternalUrl(element.href) || element.external ? _react2.default.createElement(
		'a',
		(0, _extends3.default)({ style: bgImage, href: element.href, title: element.text, target: '_blank', onClick: props.action ? props.action : null, onMouseEnter: props.hoverAction ? props.hoverAction : null }, element.attributes),
		content
	) : _react2.default.createElement(
		_reactRouter.Link,
		(0, _extends3.default)({ style: bgImage, to: element.href, onClick: props.action ? props.action : null, onMouseEnter: props.hoverAction ? props.hoverAction : null }, element.attributes),
		content
	);

	return _react2.default.createElement(
		'span',
		{ className: customClass },
		estrenoInfo,
		richLink
	);
};

RichLink.contextTypes = {
	baseUrl: _propTypes2.default.string.isRequired,
	project: _propTypes2.default.string.isRequired
};

exports.default = RichLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Links/RichLink.jsx
// module id = 715
// module chunks = 0